module.exports = __webpack_public_path__ + "img/restoxmas.2116a2ad.jpg";